import React from 'react';
import { Crown, ArrowRight, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PricingBanner = ({ subscriptionPlan, subscriptionStatus, adminGrantedPremium, trialEndDate }) => {
  const navigate = useNavigate();

  // Don't show for premium users (active subscription or admin granted)
  if (adminGrantedPremium) {
    return null;
  }
  
  if (subscriptionPlan === 'premium' && subscriptionStatus === 'active') {
    return null;
  }

  // Calculate days left in trial
  const daysLeft = trialEndDate 
    ? Math.max(0, Math.ceil((new Date(trialEndDate) - new Date()) / (1000 * 60 * 60 * 24)))
    : 0;

  // Show trial banner for users on trial
  if (subscriptionStatus === 'trial' && daysLeft > 0) {
    return (
      <div 
        data-testid="trial-banner"
        className="rounded-2xl p-5 mb-6"
        style={{ 
          background: 'linear-gradient(135deg, #f0f9f8 0%, #e8f5f3 100%)',
          border: '2px solid #A2DAD3'
        }}
      >
        <div className="flex items-center gap-4">
          <div className="flex-shrink-0">
            <Clock size={28} style={{ color: '#A2DAD3' }} />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold mb-1" style={{ color: '#333' }}>
              Premium Trial Active
            </h3>
            <p className="text-sm text-gray-600">
              You have <span className="font-bold" style={{ color: '#A2DAD3' }}>{daysLeft} days</span> left in your trial. 
              Enjoy all premium features!
            </p>
          </div>
          <button
            onClick={() => navigate('/subscription')}
            className="btn flex items-center gap-2 px-4 py-2 text-sm"
            style={{ backgroundColor: '#A2DAD3', color: 'white' }}
          >
            View Plans
            <ArrowRight size={14} />
          </button>
        </div>
      </div>
    );
  }

  // Show upgrade banner for free/expired users
  return (
    <div 
      data-testid="upgrade-banner"
      className="rounded-2xl p-6 mb-6"
      style={{ 
        background: 'linear-gradient(135deg, #A2DAD3 0%, #8fc9c0 100%)',
        color: 'white'
      }}
    >
      <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex-shrink-0">
          <Crown size={32} />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-bold mb-2">
            {subscriptionStatus === 'expired' ? 
              'Your trial has ended' : 
              'Start free with one patient'}
          </h3>
          <p className="text-sm opacity-90 mb-1">
            Upgrade anytime to manage multiple patients and unlock advanced features.
          </p>
          <div className="flex items-center gap-4 my-3">
            <div className="text-center">
              <div className="text-2xl font-bold">$5</div>
              <div className="text-xs opacity-80">per month</div>
            </div>
            <div className="text-xl opacity-60">or</div>
            <div className="text-center">
              <div className="text-2xl font-bold">$39</div>
              <div className="text-xs opacity-80">per year</div>
            </div>
          </div>
        </div>
        <button
          onClick={() => navigate('/subscription')}
          className="btn flex items-center gap-2 px-5 py-2"
          style={{ backgroundColor: 'white', color: '#A2DAD3' }}
        >
          {subscriptionStatus === 'expired' ? 'Upgrade Now' : 'Learn More'}
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default PricingBanner;
